import Image from "next/image"
import {
  HiOutlineCheckBadge,
  HiOutlineCursorArrowRays,
  HiOutlineGlobeAmericas,
  HiOutlineMap,
} from "react-icons/hi2"

const statsArr = [
  {
    title: "2,500+ drivers",
    description: "Actively competing for your business.",
    icon: (
      <HiOutlineGlobeAmericas className="h-9 w-9 min-w-max mr-4 stroke-1" />
    ),
  },
  {
    title: "90% of listings",
    description: "Receive a quote in less than 10 minutes.",
    icon: (
      <HiOutlineCursorArrowRays className="h-9 w-9 min-w-max mr-4 stroke-1" />
    ),
  },
  {
    title: "100,000,00+",
    description: "Miles driven by qualified transporters.",
    icon: <HiOutlineMap className="h-9 w-9 min-w-max mr-4 stroke-1" />,
  },
  {
    title: "14+ years experience",
    description: "Shipping what matters most.",
    icon: (
      //   <Image
      //     className="h-9 w-9 min-w-max mr-4 stroke-1"
      //     src="/icons/14-badge.svg"
      //     alt=""
      //     height={36}
      //     width={36}
      //   />
      <HiOutlineCheckBadge className="h-9 w-9 min-w-max mr-4 stroke-1" />
    ),
  },
]

export default function Stats() {
  return (
    <section className="relative w-fit mx-auto header-padding grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-10">
      {statsArr.map(({ title, description, icon }, i) => (
        <figure className="w-full flex flex-row" key={`Stats/figure/${i}`}>
          {/* <Image
            className="h-16 w-16 p-1 mr-4 drop-shadow-md fill-gray8"
            src={icon}
            alt=""
            width={100}
            height={100}
          /> */}
          {icon}
          <div className="">
            <p className="font-montserrat text-gray8 text-xl">{title}</p>
            <p className="text-gray8">{description}</p>
          </div>
        </figure>
      ))}
    </section>
  )
}
